export function themeStyles(theme: any) {
  return {
    ...theme,
    borderRadius: 0,
    borderColor: '#242424',
    colors: {
    ...theme.colors,
      primary25: '#2f98e0',
      primary: '#2f98e0',
      neutral0: '#242424',
    }
  }
}

export const customSelectStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    padding: "10px 20px",
    width: "100%",
    fontSize: "0.8em",
    color: "#000",
    backgroundColor: "none",
    cursor: "pointer"
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    color: "#242424"
  }),
  container: (provided: any) => ({
    ...provided,
      border: "1px solid #242424",
      width: "100%",
      height: "50px",
      position: "relative"
  }),
  control: (provided: any) => ({
    ...provided,
    // none of react-select's styles are passed to <Control />
    width: "100%",
    height: "100%",
    margin: 0,
    backgroundColor: "none",
    position: "relative",
    float: "none",
    borderRadius: "0",
    border: "none"
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#242424",
    fontWeight: "normal",
    paddingLeft: "12px",
    width: "100%",
    cursor: "pointer"
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "100%",
    marginLeft: 0,
    marginTop: 0,
    border: 0,
    borderRadius: 0,
    backgroundColor: "#e8e8e8",
    overflowY: "scroll",
    cursor: "pointer"
  }),
  singleValue: (provided:any) => ({
    ...provided,
    color: "#242424",
    fontWeight: "normal",
    paddingLeft: "12px",
    width: "100%",
    cursor: "pointer"
  })
}



// WEBPACK FOOTER //
// ./src/pages/campaign/themeStyles.js